import * as React from 'react';
import { useSelector } from 'react-redux';

import Tooltip from 'components/Tooltip';
import { watermarkLockStateSelector } from 'redux/modules/embed/selectors';
import { block } from '../../utils';

const NO_ASSETS_MESSAGE = 'Add assets below first';

export interface WatermarkToolTipsProps {
  show?: boolean;
  children: React.ReactNode;
}

const WatermarkToolTip: React.SFC<WatermarkToolTipsProps> = ({
  show,
  children,
}) => {
  const lockState = useSelector(watermarkLockStateSelector);
  const content = lockState.tooltip ?? NO_ASSETS_MESSAGE;
  return (
    <Tooltip
      animation={false}
      content={content}
      id="video-options-watermark-tooltip"
      placement="bottom"
      preventHideOnHover={false}
      className={block('tooltip', {
        enabled: show,
      })}
    >
      <div className={block('tile-wrapper')}>{children}</div>
    </Tooltip>
  );
};

export default WatermarkToolTip;
